module.exports = __webpack_public_path__ + "static/media/demo-microsoft-vr.a19c8447.jpg";